export enum Permission {
  ViewChatTraces = 1,
  BetaAccess = 2,
  ApplyFilters = 3,
  BullDashboard = 4,
  BrandingMain = 5,
  DemoMain = 6,
}